/**
 * Log levels supported by Loggers.
 * When a level is set, all logs of that level and higher will be logged.
 * @type {Object}
 */
export const logLevels = {
  TRACE: 'TRACE',
  DEBUG: 'DEBUG',
  INFO: 'INFO',
  WARN: 'WARN',
  ERROR: 'ERROR',
  SILENT: 'SILENT'
}

/**
 * Numeric values for each log level.
 * When a level is set, all logs of that level and higher will be logged.
 * @type {Object}
 */
export const levelValues = {
  TRACE: 0,
  DEBUG: 1,
  INFO: 2,
  WARN: 3,
  ERROR: 4,
  SILENT: 5
}

/**
 * Supported Log methods and their set log level; `<logMethod>: <logLevel>`
 * Used to construct the logging methods on a Logger.
 * @type {Object}
 */
export const logMethods = {
  // Standard methods.
  trace: logLevels.TRACE,
  debug: logLevels.DEBUG,
  info: logLevels.INFO,
  warn: logLevels.WARN,
  error: logLevels.ERROR,
  // Extra console methods.
  log: logLevels.DEBUG,
  group: logLevels.DEBUG,
  groupEnd: logLevels.DEBUG,
  groupCollapsed: logLevels.DEBUG
}

/**
 * The log level for all timer methods.
 * @type {string}
 */
export const timeLevel = logLevels.DEBUG
